'use client'
import React, { HTMLAttributes, ReactElement, ReactNode } from 'react'

export interface DataListCellProps extends HTMLAttributes<HTMLLIElement> {
    children: ReactNode
    compact?: boolean
}

export const DataListCell = ({ children, compact = false, ...rest }: DataListCellProps): ReactElement => {
    const defaultStyling = 'grow pl-3 py-4 pr-7'
    const compactStyling = 'p-2 justify-center flex'

    return (
        <li
            {...rest}
            role="cell"
            className={`flex basis-0 items-center text-text-default ${rest.className || ''} ${compact ? compactStyling : defaultStyling
                }`}
        >
            {children}
        </li>
    )
}
